module.exports = __webpack_public_path__ + "static/media/Integral Transform & Comp Analysis.bfc6c54f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MAT/Integral Transform & Comp Analysis.pdf
// module id = 132
// module chunks = 0